module.exports = __webpack_public_path__ + "static/videoPoster-0f4d0eca0903970d99df6021769a5c8e.jpg";